// «Повторить движение»: что проверяем у загруженного ролика сами — без нейросети и денег (11.10, макет R3 «Хороший ролик —
// до оплаты»): формат и размер кадра словами и размер против правила нейросети там, где оно известно (Kling Motion Control).

// Пределы размера кадра Kling Motion Control: вне их штатная ручка видео масштабирует ролик (services/motion_control_input).
const KLING_MIN_SIDE = 340
const KLING_MAX_SIDE = 3850

/** Формат кадра словами: «9:16», «16:9», «1:1»… — ближайший привычный, иначе «вертикальный» / «горизонтальный». */
export function aspectWords(w: number, h: number): string {
	const r = w / h
	const known: [number, string][] = [[9 / 16, '9:16'], [16 / 9, '16:9'], [1, '1:1'], [4 / 5, '4:5'], [3 / 4, '3:4'], [4 / 3, '4:3'], [21 / 9, '21:9']]
	const hit = known.find(([k]) => Math.abs(r - k) / k < 0.03)
	if (hit) return `${r < 1 ? 'Вертикальный' : r > 1 ? 'Горизонтальный' : 'Квадратный'} ${hit[1]}`
	return r < 1 ? 'Вертикальный' : r > 1 ? 'Горизонтальный' : 'Квадратный'
}

/** Что проверили у загруженного ролика сами: формат и размер кадра — как есть, и размер кадра против правила Kling
 *  Motion Control (вне 340–3850 px штатная ручка видео масштабирует ролик перед отправкой — api/v1/video
 *  _prepare_motion_video). У «фона из ролика» правил размера мы не знаем — только формат. */
export function clipChecks(w: number | null | undefined, h: number | null | undefined, replace: boolean): { tone: 'ok' | 'warn'; text: string }[] {
	if (!w || !h) return []
	const out: { tone: 'ok' | 'warn'; text: string }[] = [{ tone: 'ok', text: `${aspectWords(w, h)} · ${w}×${h}` }]
	if (!replace) {
		const short = Math.min(w, h), long = Math.max(w, h)
		if (short < KLING_MIN_SIDE) out.push({ tone: 'warn', text: `Кадр мелкий — перед отправкой растянем до ${KLING_MIN_SIDE} px по короткой стороне` })
		else if (long > KLING_MAX_SIDE) out.push({ tone: 'warn', text: `Кадр очень крупный — перед отправкой уменьшим до ${KLING_MAX_SIDE} px по длинной стороне` })
	}
	return out
}
